import Vue from 'vue'
export default new Vue()



//////////////////
// WEBPACK FOOTER
// ./packages/api/bus.js
// module id = null
// module chunks = 